//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name:'SilvermanAnderson',
  data() {
    return {
      form:{
        chest:'',
        intercostal:'',
        xiphoid:'',
        nasal:'',
        grunt:''
      },
      hasScore:false,
      disabled:false,
      ChestMovementList:[
        {value:"0",name:'相同'},
        {value:"1",name:'呼吸延迟'},
        {value:"2",name:'胸腹矛盾呼吸运动'}
      ],
      IntercostalRetractionList:[
        {value:"0",name:'无'},
        {value:"1",name:'轻度'},
        {value:"2",name:'显著'}
      ],
      XiphoidRetractionsList:[
        {value:"0",name:'无'},
        {value:"1",name:'轻度'},
        {value:"2",name:'显著'}
      ],
      NasalFlaringList:[
        {value:"0",name:'无'},
        {value:"1",name:'轻度'},
        {value:"2",name:'显著'}
      ],
      ExpiratoryGruntList:[
        {value:"0",name:'无'},
        {value:"1",name:'可用听诊器听到'},
        {value:"2",name:'无需听诊器即可听到'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = form.chest + form.intercostal + form.xiphoid + form.nasal + form.grunt
        console.log(result,'result----------------');
        self.hasScore = true
        return String(result)
      }
    }
  },
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ObGyn/SilvermanAnderson.vue